import React from 'react';
import AppActionMenu from '../../../../components/AppActionMenu';
import { getStatusBadgeClass } from '../../../../constants/statusColors';

export default function EmpIncentivesTable({
  records = [],
  isLoading = false,
  onResetFilters,
}) {
  if (isLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-lowest">
        <div className="flex flex-col items-center gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <span className="text-xs font-semibold text-on-surface-variant">Loading employee incentives...</span>
        </div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="flex h-64 w-full flex-col items-center justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-8 text-center">
        <span className="material-symbols-outlined mb-2 text-4xl text-outline-variant">
          add_card
        </span>
        <h3 className="font-display text-sm font-bold text-black">No entries meet selected criteria</h3>
        <p className="mt-1 text-xs text-slate-600 max-w-md">
          Either there are no entries in the selected module or you have selected invalid filter conditions.
        </p>
        {onResetFilters && (
          <button
            type="button"
            onClick={onResetFilters}
            className="mt-4 inline-flex items-center gap-1.5 rounded-xl bg-primary/10 px-3.5 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-sm">refresh</span>
            <span>Reset Filters</span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm border-collapse">
          <thead>
            <tr className="border-b border-outline-variant/25 bg-surface-container-low/40 text-[11px] font-extrabold uppercase tracking-wider text-black">
              <th className="py-3.5 px-6 text-black">NAME</th>
              <th className="py-3.5 px-6 text-black">VNO</th>
              <th className="py-3.5 px-6 text-black">VDATE</th>
              <th className="py-3.5 px-6 text-black">PAYHEAD</th>
              <th className="py-3.5 px-6 text-right text-black">AMOUNT</th>
              <th className="py-3.5 px-6 text-center text-black">STATUS</th>
              <th className="py-3.5 px-6 text-right w-20 text-black">ACTIONS</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/15">
            {records.map((item, index) => {
              return (
                <tr
                  key={item.id || index}
                  className="transition-colors hover:bg-surface-container-low/50 group"
                >
                  {/* Name */}
                  <td className="py-4 px-6 whitespace-nowrap">
                    <div className="flex items-center">
                      <span className="font-bold text-sm text-on-surface font-sans">
                        {item.name || 'Divyanshu Singh'}
                      </span>
                      {item.employeeId && (
                        <span className="text-xs text-slate-600 font-sans tabular-nums font-semibold ml-1.5">
                          ({item.employeeId})
                        </span>
                      )}
                    </div>
                  </td>

                  {/* Vno */}
                  <td className="py-4 px-6 text-xs font-mono font-medium text-slate-700 whitespace-nowrap">
                    {item.vno || '—'}
                  </td>

                  {/* vDate */}
                  <td className="py-4 px-6 font-sans tabular-nums font-medium text-sm text-on-surface whitespace-nowrap">
                    {item.vDateDisplay || item.vDate}
                  </td>

                  {/* PayHead */}
                  <td className="py-4 px-6 whitespace-nowrap">
                    <div className="flex flex-col">
                      <span className="font-semibold text-sm text-primary font-sans">
                        {item.payHead}
                      </span>
                      {item.remarks && (
                        <span className="text-[11px] text-slate-500 font-medium truncate max-w-xs">
                          {item.remarks}
                        </span>
                      )}
                    </div>
                  </td>

                  {/* Amount */}
                  <td className="py-4 px-6 text-right whitespace-nowrap font-sans tabular-nums font-bold text-sm text-emerald-600">
                    {item.formattedAmount || `₹${Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
                  </td>

                  {/* Status */}
                  <td className="py-4 px-6 text-center whitespace-nowrap">
                    <span
                      className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-bold ${getStatusBadgeClass(
                        item.status
                      )}`}
                    >
                      {item.status || 'Approved'}
                    </span>
                  </td>

                  {/* Actions */}
                  <td className="py-4 px-6 text-right whitespace-nowrap">
                    <div className="flex items-center justify-end">
                      <AppActionMenu
                        triggerLabel=""
                        triggerIcon="more_vert"
                        showChevron={false}
                        triggerClassName="rounded-lg p-1 text-[#4b5563] hover:text-black hover:bg-surface-container-high transition bg-transparent cursor-pointer"
                        items={[
                          {
                            key: 'print',
                            label: 'Print Voucher',
                            icon: 'print',
                            onClick: () => window.print(),
                          },
                        ]}
                        onSelect={(key) => {
                          if (key === 'print') window.print();
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
